import { summarize } from "./data";
import { getChangeData } from "./changeData";
import calculateMethodMixAndShareTableData from "./methodMixAndShareTableData";

const calculateMethodVsSectorTableData = (databases, indicatorId, areaId) => {
  const database = databases.allSectorTotals;

  const sectorIds = new Set([3, 4, 5, 6]);

  const data = database.data
    .filter(
      datum =>
        datum.area === areaId &&
        datum.indicator === indicatorId &&
        sectorIds.has(datum.sector) &&
        datum.year === 2018
    )
    .map(datum => ({
      ...datum,
      sector: database.sectors[datum.sector],
      method: database.methods[datum.method]
    }));

  const summary = summarize(data, ["sector", "method"]);

  const methodTotals = summarize(
    data.filter(datum => datum.sector !== "Private"),
    ["method"]
  ).map(datum => ({
    ...datum,
    sector: "Total"
  }));

  const sectorTotals = summarize([...data, ...methodTotals], ["sector"]).map(
    datum => ({
      ...datum,
      method: "Total"
    })
  );

  return [...summary, ...methodTotals, ...sectorTotals];
};

const calculateChangeByMethodTableData = (databases, indicatorId, areaId) => {
  const database = databases.core;

  return getChangeData(
    database.data.filter(
      datum => datum.area === areaId && datum.indicator === indicatorId
    ),
    "method"
  ).map(datum => ({
    ...datum,
    method: datum.method !== "Total" ? database.methods[datum.method] : "Total"
  }));
};

export default (databases, areaId) => ({
  // Annex A.1
  contraceptionUsersTable: calculateMethodVsSectorTableData(
    databases,
    4,
    areaId
  ),
  // Annex A.2
  userMethodMixAndShareTable: calculateMethodMixAndShareTableData(
    databases.core,
    4,
    areaId
  ),
  // Annex A.3
  changeInUsersTable: calculateChangeByMethodTableData(databases, 4, areaId),
  // Annex A.4
  contraceptionCostTable: calculateMethodVsSectorTableData(
    databases,
    6,
    areaId
  ),
  // Annex A.5
  costMethodMixAndShareTable: calculateMethodMixAndShareTableData(
    databases.core,
    6,
    areaId
  ),
  // Annex A.6
  changeInCostTable: calculateChangeByMethodTableData(databases, 6, areaId),
  // Annex A.7
  contraceptionQuantityTable: calculateMethodVsSectorTableData(
    databases,
    5,
    areaId
  ),
  // Annex A.8
  quantityMethodShareTable: calculateMethodMixAndShareTableData(
    databases.core,
    5,
    areaId
  ),
  // Annex A.9
  changeInQuantityTable: calculateChangeByMethodTableData(databases, 5, areaId)
});
